import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const FormDetail = () => {
  const location = useLocation();
  const formData = location.state?.formData;
  return (
    <>
      <section className="py-5 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div
                className="p-4 border rounded-4 bg-light shadow border-dashed mx-auto pb-5"
                style={{ maxWidth: 800 }}
              >
                <h5 className="border-bottom pb-3 fw-bold mb-4 text-cetner">
                  Contact Form Details
                </h5>

                {formData ? (
                  <div className="row">
                    <div className="col-md-6 my-2">
                      <p className="">
                        <strong>Name:</strong> {formData?.name || "N/A"}
                      </p>
                    </div>
                    <div className="col-md-6 my-2">
                      <p className="">
                        <strong>Email:</strong> {formData?.email || "N/A"}
                      </p>
                    </div>
                    <div className="col-md-12 my-2">
                      <p>
                        <strong className="d-block">Message:</strong>{" "}
                        {formData?.description || "N/A"}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="col-md-12 my-2 text-center">
                    <p>No data available.</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default FormDetail;
